module.exports = __webpack_public_path__ + "img/top_Back.70807ef2.jpg";